import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ButtonComponent } from 'src/app/components/button/button.component';

export interface Platform {
  id: string;
  name: string;
  description: string;
  iconPath: string;
}

@Component({
  selector: 'app-platforms-tab',
  templateUrl: './platforms-tab.component.html',
  styleUrls: ['./platforms-tab.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent],
})
export class PlatformsTabComponent {
  public platforms: Platform[] = [];
  public selectedPlatformId: string | null = null;

  constructor(
    private readonly _matDialog: MatDialog,
    private readonly _router: Router
  ) {}

  public get hasPlatforms(): boolean {
    return this.platforms.length > 0;
  }

  public onConnectIntegration(): void {
    this._router.navigate(['/app/connect/integrations']);
  }

  public onAddPlatform(): void {
    // Will be implemented with Add Platform Dialog
    this._router.navigate(['/app/connect/integrations']);
  }

  public onPlatformSelect(platformId: string): void {
    this.selectedPlatformId = platformId;
  }

  public isPlatformSelected(platformId: string): boolean {
    return this.selectedPlatformId === platformId;
  }
}
